import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './W_BillingTab.module.css';
import A_ImageIdentityElement from '@/assets/images/A_ImageIdentityElement.jpg';
import A_BenefitItem from '@/components/A_Atoms/A_BenefitItem/A_BenefitItem';
import Q_DecorativeBullet_01 from '@/assets/images/Q_DecorativeBullets/Q_DecorativeBullet_01.jpg';
import Q_DecorativeBullet_02 from '@/assets/images/Q_DecorativeBullets/Q_DecorativeBullet_02.jpg';
import Q_DecorativeBullet_03 from '@/assets/images/Q_DecorativeBullets/Q_DecorativeBullet_03.jpg';
import cn from 'classnames';
import A_Button from '@/components/A_Atoms/A_Button/A_Button';
import { PATHS } from '@/constants/paths';
import { useLanguage } from '@/contexts/LanguageContext';
import { getTranslation } from '@/constants/translations';

interface W_BillingTabProps {
  hasSubscription: boolean;
}

export const W_BillingTab: React.FC<W_BillingTabProps> = ({
  hasSubscription,
}) => {
  const navigate = useNavigate();
  const { language } = useLanguage();

  const nextPaymentDate = new Date();
  nextPaymentDate.setMonth(nextPaymentDate.getMonth() + 1);
  const formattedNextPayment = nextPaymentDate.toLocaleDateString(
    language === 'ru' ? 'ru-RU' : 'en-US',
    { day: '2-digit', month: 'long', year: 'numeric' }
  );

  const handleSubscribeClick = () => {
    navigate(PATHS.PAYMENT_SUBSCRIPTION);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.header_wrapper}>
        <h4 className={styles.title}>
          {getTranslation(language, 'profileBilling.title')}
        </h4>
        {hasSubscription ? (
          ''
        ) : (
          <h3 className={styles.subscription_status_text}>
            {getTranslation(language, 'profileBilling.pricePromo')}
          </h3>
        )}
      </div>
      <p className={cn(styles.description, 'text-p-2')}>
        {getTranslation(language, 'profileBilling.includes')}
      </p>
      <div className={styles.benefits_wrapper}>
        <A_BenefitItem
          image={<img src={Q_DecorativeBullet_01} alt='pro' />}
          description={getTranslation(
            language,
            'profileBilling.benefits.unlimitedCapsules'
          )}
        />
        <A_BenefitItem
          image={<img src={Q_DecorativeBullet_02} alt='pro' />}
          description={getTranslation(
            language,
            'profileBilling.benefits.comments'
          )}
        />
        <A_BenefitItem
          image={<img src={Q_DecorativeBullet_03} alt='pro' />}
          description={getTranslation(
            language,
            'profileBilling.benefits.giftReactions'
          )}
        />
      </div>

      <div className={styles.image_wrapper}>
        <img src={A_ImageIdentityElement} alt='pro' />
      </div>
      <div className={styles.button_wrapper}>
        {hasSubscription ? (
          <span className={cn(styles.price, 'text-button')}>
            {getTranslation(language, 'profileBilling.price')}
          </span>
        ) : (
          <span className={cn(styles.price, 'text-p-7')}>
            {getTranslation(language, 'profileBilling.nextPaymentPrefix')}{' '}
            {formattedNextPayment}
          </span>
        )}
        {hasSubscription ? (
          <A_Button
            variant='primary'
            size='medium'
            type='button'
            onClick={handleSubscribeClick}
          >
            {getTranslation(language, 'profileBilling.subscribe')}
          </A_Button>
        ) : (
          <A_Button variant='secondary' size='medium' type='submit'>
            {getTranslation(language, 'profileBilling.unsubscribe')}
          </A_Button>
        )}
      </div>
    </div>
  );
};
